import { DescriptionOption, ThirdPartyTemplateOption } from "../field-type";

// ---- Description Parameters ----

export type PaymentDescriptionParameters = {
    withThirdPart: boolean;
}

export type SellInvoiceDescriptionParameters = {
    withThirdPart: boolean;
}

export type BuyInvoiceDescriptionParameters = {
    withThirdPart: boolean;
}












// ---- Entry Description ----

export const defaultEntryDescriptionEmptyFieldOption: DescriptionOption =
{
    label: 'Pas de libellé global',
    hasTemplate: false
};

export const defaultPaymentEntryDescriptionDynamicFieldOption: DescriptionOption =
{
    label: 'Personnalisé',
    hasTemplate: true,
    showTemplateField: true,
    templateValue: '{{ transaction.type }} • {{ transaction.documentRef }} • {{ transaction.creationDate | date("yyyy-MM-dd") }}'
};

export const defaultInvoiceEntryDescriptionDynamicFieldOption: DescriptionOption =
{
    label: 'Personnalisé',
    hasTemplate: true,
    showTemplateField: true,
    templateValue: '{{ invoice.type }} • {{ invoice.documentRef }} • {{ invoice.creationDate | date("yyyy-MM-dd") }}'
};

// ---- Entry Description - Payment ----

export const paymentEntryDescriptionThirdPartFieldOption: DescriptionOption =
{
    label: 'Nom du client / fournisseur',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }}',
};

export function getPaymentEntryDescriptionFieldOptions(
    { withThirdPart }: PaymentDescriptionParameters
): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryDescriptionEmptyFieldOption);
    if (withThirdPart) { descriptionOptions.push(paymentEntryDescriptionThirdPartFieldOption); }
    descriptionOptions.push(defaultPaymentEntryDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Entry Description - Sell Invoices ----

export const sellInvoiceEntryDescriptionThirdPartFieldOption: DescriptionOption =
{
    label: 'Nom du client',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }}',
};

export const sellInvoiceEntryDescriptionDocumentRefFieldOption: DescriptionOption =
{
    label: 'Numéro de pièce',
    hasTemplate: true,
    templateValue: '{{ invoice.documentRef }}',
};

export const sellInvoiceEntryDescriptionThirdPartAndDocumentRefFieldOption: DescriptionOption =
{
    label: 'Nom du client + Numéro de pièce',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }} • {{ invoice.documentRef }}',
};

export function getSellInvoiceEntryDescriptionFieldOptions(
    { withThirdPart }: SellInvoiceDescriptionParameters
): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryDescriptionEmptyFieldOption);
    if (withThirdPart) {
        descriptionOptions.push(sellInvoiceEntryDescriptionThirdPartFieldOption);
        descriptionOptions.push(sellInvoiceEntryDescriptionDocumentRefFieldOption);
        descriptionOptions.push(sellInvoiceEntryDescriptionThirdPartAndDocumentRefFieldOption);
    }
    descriptionOptions.push(defaultInvoiceEntryDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Entry Description - Buy Invoices ----

export const buyInvoiceEntryDescriptionThirdPartFieldOption: DescriptionOption =
{
    label: 'Nom du fournisseur',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }}',
};

export const buyInvoiceEntryDescriptionDocumentRefFieldOption: DescriptionOption =
{
    label: 'Numéro de pièce',
    hasTemplate: true,
    templateValue: '{{ invoice.documentRef }}',
};

export const buyInvoiceEntryDescriptionThirdPartAndDocumentRefFieldOption: DescriptionOption =
{
    label: 'Nom du fournisseur + Numéro de pièce',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }} • {{ invoice.documentRef }}',
};

export function getBuyInvoiceEntryDescriptionFieldOptions(
    { withThirdPart }: BuyInvoiceDescriptionParameters
): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryDescriptionEmptyFieldOption);
    if (withThirdPart) {
        descriptionOptions.push(buyInvoiceEntryDescriptionThirdPartFieldOption);
        descriptionOptions.push(buyInvoiceEntryDescriptionDocumentRefFieldOption);
        descriptionOptions.push(buyInvoiceEntryDescriptionThirdPartAndDocumentRefFieldOption);
    }
    descriptionOptions.push(defaultInvoiceEntryDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Entry Description - Bank ----

export const bankEntryDescriptionDescriptionFieldOption: DescriptionOption =
{
    label: 'Libellé de l\'opération',
    hasTemplate: true,
    templateValue: '{{ transaction.description }}',
};

export function getBankEntryDescriptionFieldOptions(): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryDescriptionEmptyFieldOption);
    descriptionOptions.push(bankEntryDescriptionDescriptionFieldOption);
    descriptionOptions.push(defaultPaymentEntryDescriptionDynamicFieldOption);

    return descriptionOptions;
}











// ---- Entry Line Description ----

export const defaultEntryLineDescriptionStandardFieldOption: DescriptionOption =
{
    label: 'Libellé détaillé',
    hasTemplate: false
};

export const defaultPaymentEntryLineDescriptionDynamicFieldOption: DescriptionOption =
{
    label: 'Personnalisé',
    hasTemplate: true,
    showTemplateField: true,
    templateValue: '{{ transaction.type }} • {{ transaction.documentRef }} • {{ transaction.creationDate | date("yyyy-MM-dd") }}'
};

export const defaultInvoiceEntryLineDescriptionDynamicFieldOption: DescriptionOption =
{
    label: 'Personnalisé',
    hasTemplate: true,
    showTemplateField: true,
    templateValue: '{{ invoice.type }} • {{ invoice.documentRef }} • {{ invoice.creationDate | date("yyyy-MM-dd") }}'
};


// ---- Entry Line Description - Payment ----

export const paymentEntryLineDescriptionThirdPartFieldOption: DescriptionOption =
{
    label: 'Nom du client / fournisseur',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }}',
};

export function getPaymentEntryLineDescriptionFieldOptions(
    { withThirdPart }: PaymentDescriptionParameters
): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryLineDescriptionStandardFieldOption);
    if (withThirdPart) { descriptionOptions.push(paymentEntryLineDescriptionThirdPartFieldOption); }
    descriptionOptions.push(defaultPaymentEntryLineDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Entry Line Description - Sell Invoices ----

export const sellInvoiceEntryLineDescriptionThirdPartFieldOption: DescriptionOption =
{
    label: 'Nom du client',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }}',
};

export const sellInvoiceEntryLineDescriptionThirdPartAndDocumentRefFieldOption: DescriptionOption =
{
    label: 'Nom du client + Numéro de pièce',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }} • {{ invoice.documentRef }}',
};

export function getSellInvoiceEntryLineDescriptionFieldOptions(
    { withThirdPart }: SellInvoiceDescriptionParameters
): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryLineDescriptionStandardFieldOption);
    if (withThirdPart) {
        descriptionOptions.push(sellInvoiceEntryLineDescriptionThirdPartFieldOption);
        descriptionOptions.push(sellInvoiceEntryLineDescriptionThirdPartAndDocumentRefFieldOption);
    }
    descriptionOptions.push(defaultInvoiceEntryLineDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Entry Line Description - Buy Invoices ----

export const buyInvoiceEntryLineDescriptionThirdPartFieldOption: DescriptionOption =
{
    label: 'Nom du fournisseur',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }}',
};

export const buyInvoiceEntryLineDescriptionThirdPartAndDocumentRefFieldOption: DescriptionOption =
{
    label: 'Nom du fournisseur + Numéro de pièce',
    hasTemplate: true,
    templateValue: '{{ thirdParty.mainName }} • {{ invoice.documentRef }}',
};

export function getBuyInvoiceEntryLineDescriptionFieldOptions(
    { withThirdPart }: BuyInvoiceDescriptionParameters
): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultEntryLineDescriptionStandardFieldOption);
    if (withThirdPart) {
        descriptionOptions.push(buyInvoiceEntryLineDescriptionThirdPartFieldOption);
        descriptionOptions.push(buyInvoiceEntryLineDescriptionThirdPartAndDocumentRefFieldOption);
    }
    descriptionOptions.push(defaultInvoiceEntryLineDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Entry Line Description - Bank ----

export const bankEntryLineDescriptionDescriptionFieldOption: DescriptionOption =
{
    label: 'Libellé de l\'opération',
    hasTemplate: true,
    templateValue: '{{ transaction.description }}',
};

export function getBankEntryLineDescriptionFieldOptions(): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(bankEntryLineDescriptionDescriptionFieldOption);
    descriptionOptions.push(defaultPaymentEntryLineDescriptionDynamicFieldOption);

    return descriptionOptions;
}











// ---- Grouping Description ----

export const defaultGroupingDescriptionEmptyFieldOption: DescriptionOption =
{
    label: 'Pas de regroupement',
    hasTemplate: false
};

export const defaultPaymentGroupingDescriptionDynamicFieldOption: DescriptionOption =
{
    label: 'Avancé',
    hasTemplate: true,
    showTemplateField: true,
    templateValue: '{{ transaction.operationDate | date("yyyy-MM-dd") }}'
};

export const defaultInvoiceGroupingDescriptionDynamicFieldOption: DescriptionOption =
{
    label: 'Avancé',
    hasTemplate: true,
    showTemplateField: true,
    templateValue: '{{ invoice.creationDate | date("yyyy-MM-dd") }}'
};

// ---- Grouping Description - Payment ----

export const paymentGroupingDescriptionOperationDateFieldOption: DescriptionOption =
{
    label: 'Regrouper les encaissements par jour',
    hasTemplate: true,
    templateValue: '{{ transaction.operationDate | date("yyyy-MM-dd") }}'
};

export const paymentGroupingDescriptionAllFieldOption: DescriptionOption =
{
    label: 'Regrouper tous les encaissements',
    hasTemplate: true,
    templateValue: '*'
};

export function getPaymentGroupingDescriptionFieldOptions(): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultGroupingDescriptionEmptyFieldOption);
    descriptionOptions.push(paymentGroupingDescriptionOperationDateFieldOption);
    descriptionOptions.push(paymentGroupingDescriptionAllFieldOption);
    descriptionOptions.push(defaultPaymentGroupingDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Grouping Description - Sell Invoice ----

export const sellInvoiceGroupingDescriptionOperationDateFieldOption: DescriptionOption =
{
    label: 'Regrouper les ventes par jour',
    hasTemplate: true,
    templateValue: '{{ invoice.creationDate | date("yyyy-MM-dd") }}'
};

export const sellInvoiceGroupingDescriptionAllFieldOption: DescriptionOption =
{
    label: 'Regrouper toutes les ventes',
    hasTemplate: true,
    templateValue: '*'
};

export function getSellInvoiceGroupingDescriptionFieldOptions(): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultGroupingDescriptionEmptyFieldOption);
    descriptionOptions.push(sellInvoiceGroupingDescriptionOperationDateFieldOption);
    descriptionOptions.push(sellInvoiceGroupingDescriptionAllFieldOption);
    descriptionOptions.push(defaultInvoiceGroupingDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Grouping Description - Buy Invoice ----

export const buyInvoiceGroupingDescriptionOperationDateFieldOption: DescriptionOption =
{
    label: 'Regrouper les achats par jour',
    hasTemplate: true,
    templateValue: '{{ invoice.creationDate | date("yyyy-MM-dd") }}'
};

export const buyInvoiceGroupingDescriptionAllFieldOption: DescriptionOption =
{
    label: 'Regrouper tous les achats',
    hasTemplate: true,
    templateValue: '*'
};

export function getBuyInvoiceGroupingDescriptionFieldOptions(): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultGroupingDescriptionEmptyFieldOption);
    descriptionOptions.push(buyInvoiceGroupingDescriptionOperationDateFieldOption);
    descriptionOptions.push(buyInvoiceGroupingDescriptionAllFieldOption);
    descriptionOptions.push(defaultInvoiceGroupingDescriptionDynamicFieldOption);

    return descriptionOptions;
}

// ---- Grouping Description - Bank ----

export const bankGroupingDescriptionOperationDateFieldOption: DescriptionOption =
{
    label: 'Regrouper les transactions bancaires par jour',
    hasTemplate: true,
    templateValue: '{{ transaction.operationDate | date("yyyy-MM-dd") }}'
};

export const bankGroupingDescriptionAllFieldOption: DescriptionOption =
{
    label: 'Regrouper toutes les transactions bancaires',
    hasTemplate: true,
    templateValue: '*'
};

export function getBankGroupingDescriptionFieldOptions(): DescriptionOption[] {
    const descriptionOptions: DescriptionOption[] = [];

    descriptionOptions.push(defaultGroupingDescriptionEmptyFieldOption);
    descriptionOptions.push(bankGroupingDescriptionOperationDateFieldOption);
    descriptionOptions.push(bankGroupingDescriptionAllFieldOption);
    descriptionOptions.push(defaultPaymentGroupingDescriptionDynamicFieldOption);

    return descriptionOptions;
}








// Third Part

export const clientThirdPartTemplatingNameFieldOption: ThirdPartyTemplateOption =
{
    label: 'Nom du client',
    hasDynamic: true,
    showAdvancedTemplateField: false,
    auxiliaryAccountDynamic: '{{ thirdParty.mainName | normalize | upper | left(8) }}',
    auxiliaryLabelDynamic: '{{ thirdParty.mainName }}'
};

export const supplierThirdPartTemplatingNameFieldOption: ThirdPartyTemplateOption =
{
    label: 'Nom du fournisseur',
    hasDynamic: true,
    showAdvancedTemplateField: false,
    auxiliaryAccountDynamic: '{{ thirdParty.mainName | normalize | upper | left(8) }}',
    auxiliaryLabelDynamic: '{{ thirdParty.mainName }}'
};

export const thirdPartTemplatingAdvancedFieldOption: ThirdPartyTemplateOption =
{
    label: 'Avancé',
    hasDynamic: true,
    showAdvancedTemplateField: true,
    auxiliaryAccountDynamic: '{{ thirdParty.mainName | normalize | upper | left(8) }}',
    auxiliaryLabelDynamic: '{{ thirdParty.mainName }}'
};

export const clientThirdPartyTemplatingOptions: ThirdPartyTemplateOption[] = [
    clientThirdPartTemplatingNameFieldOption,
    thirdPartTemplatingAdvancedFieldOption
]

export const supplierThirdPartyTemplatingOptions: ThirdPartyTemplateOption[] = [
    supplierThirdPartTemplatingNameFieldOption,
    thirdPartTemplatingAdvancedFieldOption
]

// Third Part - counterpart

export const clientThirdPartCounterpartTemplatingNameFieldOption: ThirdPartyTemplateOption =
{
    label: 'Nom du client',
    hasDynamic: true,
    showAdvancedTemplateField: false,
    auxiliaryAccountDynamic: '{{ counterpart.thirdParty.mainName | normalize | upper | left(8) }}',
    auxiliaryLabelDynamic: '{{ counterpart.thirdParty.mainName }}'
};

export const supplierThirdPartCounterpartTemplatingNameFieldOption: ThirdPartyTemplateOption =
{
    label: 'Nom du fournisseur',
    hasDynamic: true,
    showAdvancedTemplateField: false,
    auxiliaryAccountDynamic: '{{ counterpart.thirdParty.mainName | normalize | upper | left(8) }}',
    auxiliaryLabelDynamic: '{{ counterpart.thirdParty.mainName }}'
};

export const thirdPartCounterpartTemplatingAdvancedFieldOption: ThirdPartyTemplateOption =
{
    label: 'Avancé',
    hasDynamic: true,
    showAdvancedTemplateField: true,
    auxiliaryAccountDynamic: '{{ counterpart.thirdParty.mainName | normalize | upper | left(8) }}',
    auxiliaryLabelDynamic: '{{ counterpart.thirdParty.mainName }}'
};

export const clientThirdPartyCounterpartTemplatingOptions: ThirdPartyTemplateOption[] = [
    clientThirdPartCounterpartTemplatingNameFieldOption,
    thirdPartCounterpartTemplatingAdvancedFieldOption
]

export const supplierThirdPartyCounterpartTemplatingOptions: ThirdPartyTemplateOption[] = [
    supplierThirdPartCounterpartTemplatingNameFieldOption,
    thirdPartCounterpartTemplatingAdvancedFieldOption
]